import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { dashboardServicesType } from "../utils/types";

const initialState: dashboardServicesType = {
    services: [
        {
            key: 'website_search',
            title: 'Search',
            iconName: 'Search',
            navigation: '/search'
        },
        {
            key: 'text_chat',
            title: 'Chat',
            iconName: 'ChatDots',
            navigation: ''
        },
        {
            key: 'live_concierge',
            title: 'Call',
            iconName: 'Headset',
            navigation: '/search'
        }
    ],
    isMobile: false
}

const dashboardSlice = createSlice({
    name:'dashboard',
    initialState,
    reducers: {
        setIsMobile: (state, action: PayloadAction<dashboardServicesType['isMobile']>) => {
            state.isMobile = action.payload
        }
    }
});

export const dashboardAction = dashboardSlice.actions;
export default dashboardSlice.reducer;